import { createI18n } from "vue-i18n";
import messages from '../translations';

const i18n = createI18n({
    globalInjection: true,
    locale: localStorage.getItem("locale") || "en",
    messages
});

export default i18n;